import { Component, OnInit } from '@angular/core';

import { AuthService } from '../../services/auth.service';
import { DashboardService } from '../../services/dashboard.service';

@Component({
  selector: 'app-overview',
  templateUrl: './overview.component.html'
})
export class OverviewComponent implements OnInit {
  stats: any = {};
  role: string | null= '';
  loading = true;

  constructor(private dashboardService: DashboardService, private authService: AuthService) { }

  ngOnInit(): void {
    this.role = this.authService.getUserRole(); // 'Admin' or 'Vendor'
    this.loadStats();
  }

  loadStats() {
    this.dashboardService.getDashboardStats(this.role).subscribe({
      next: (res) => {
        this.stats = res;
        this.loading = false;
      },
      error: () => (this.loading = false)
    });
  }
}

